<template>
    <div class="personcenter">
        <div class="title">
           <h3><span>学习说明</span></h3>
        </div>
        <div class="content">
            <!-- <div style="padding-bottom:20px;">专业技术人员参加继续教育的时间要求学习45小时且满60学时才能参加考试</div> -->
            <ul class="clearfix">
                <li>
                    <p><img src="../assets/center01.png" alt=""></p>
                    <h4>(1) 用户注册 <span style="font-weight:bold;color:red;">(已完成)</span></h4>
                    <p> 用户通过主页完成注册后，使用身份证号作为账号及所设密码，登录个人中心。</p>

                </li>
                <li>
                    <p><img src="../assets/center02.png" alt=""></p>
                    <h4>(2) 选课与激活</h4>
                    <p>用户可通过“全部课程”进行选课；选课时请依据管理部门有关规定来实施；选课完成后，可通过线上缴费方式（支付宝）或线下集体报名（学时卡）等方式激活课程。</p>
                </li>
                <li>
                    <p><img src="../assets/center03.png" alt=""></p>
                    <h4>(3) 在线学习</h4>
                    <p>用户可通过“我的课程”点选目标课程进行浏览和学习。学习进度和时长由系统自动保存。</p>

                </li>
                <li>
                    <p><img src="../assets/center05.png" alt=""></p>
                    <h4>(4) 档案查询</h4>
                    <p>用户在线学习时长达到有关要求后，请用户认真学习后，查看档案记录。</p>
                </li>
                <li>
                    <p><img src="../assets/center04.png" alt=""></p>
                    <h4>(5) 互动问答</h4>
                    <p>用户在学习课程结束后，可以根据自己的问题进行提问。</p>
                </li>

               <!-- <li>
                    <p><img src="../assets/center06.png" alt=""></p>
                    <h4>(6) 记录查询</h4>
                    <p>用户可通过“考试记录”查询考试通过情况；可通过“档案记录”查询所获学时及证书情况；可通过“我的订单”查询课程消费情况。</p>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data (){
            return {
                year:''

            }
        },
        created (){
             var date = new Date();
             this.year = date.getFullYear();
        },
        methods:{

        }

    }
</script>

<style lang="less" scoped>
.personcenter{
     width: 948px;
    background-color: #fff;
    padding:0 20px 30px;
    box-sizing: border-box;
    .title{
        width: 100%;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #f4f4f4;
        margin-bottom:20px;
          box-sizing: border-box;
        h3{
            color:#ad0008;
            span{
                padding-bottom:13px;
                border-bottom:2px solid #ad0008;
                box-sizing: border-box;
            }
        }
    }
    .content{
         width: 100%;
        //  padding-bottom:100px;
         box-sizing: border-box;
         ul{
             width: 100%;
             li{
                 float: left;
                 width: 48%;
                 margin-bottom:15px;
                 cursor: default;
                &:nth-child(2n+1){
                    margin-right:30px;
                }
                h4{
                    color:#ad0008;
                    line-height: 30px;
                }
                p{
                    line-height: 30px;
                }
             }
         }
    }



}

</style>



// WEBPACK FOOTER //
// src/components/personcenter.vue